import React, { useState, useEffect, useCallback } from 'react';
import { ISearchInputProps } from 'types';
import { Input, Spin } from 'antd';
import "./style.scss";
import { SearchOutlined } from '@ant-design/icons';

export const SearchInput: React.FC<ISearchInputProps> = ({ onSearch, placeholder }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [runSearch, setRunSearch] = useState(false);
  const [loading, setLoading] = useState(false);

  const searchData = useCallback(async () => {
    setLoading(true);
    onSearch(searchTerm);
    setLoading(false);
    setRunSearch(false);
  }, [searchTerm, onSearch]);

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      setRunSearch(true)
    }
  };

  const handleKeyUp = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Backspace' && searchTerm.trim() === '') {
      setRunSearch(true)
    }
  };

  useEffect(() => {
    if(runSearch){
      searchData()
    }

  }, [runSearch, searchData]);

  return (
    <div className='search-input-container d-flex' style={{minWidth: 250}}>
      <div className="input-group">
        <Input
          className="form-control"
          placeholder={ placeholder?? "Digite para buscar" }
          value={searchTerm}
          onChange={(e) => {setSearchTerm(e.target.value)}}
          onKeyDown={handleKeyDown}
          onKeyUp={handleKeyUp}
        />
        <button onClick={() => setRunSearch(true)} className="input-group-text">{loading ? <Spin/> : <SearchOutlined />}</button>
      </div>
    </div>
  );
};
